import { Footer } from '../components/Footer';
import { GIRL_PRESETS } from './Generate';
import { GAME_GIRLS } from '../data/gameGirls';
import './Landing.css';

const CDN = 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude';

const TIERS = [
    {
        key: 'starter',
        name: 'Starter',
        price: '$9.99',
        per: '$0.20 / photo',
        features: ['50 photo generations', '10 video generations', 'HD quality'],
    },
    {
        key: 'premium',
        name: 'Premium',
        price: '$19.99',
        old: '$60',
        per: '$0.05 / photo',
        badge: 'Save 75%',
        features: ['400 photo generations', '20 video generations', 'Priority queue', 'Full HD'],
        popular: true,
    },
];

const FAQ = [
    {
        q: 'Can I upload my own photo?',
        a: 'No. Makeporn does not accept any user-uploaded images. Everything you see is generated by our model from your prompt.',
    },
    {
        q: 'Are these real people?',
        a: 'No. All girls and scenes are 100% AI-generated. No real person is depicted. Read our §2257 statement for the full picture.',
    },
    {
        q: 'How does billing work?',
        a: 'Pay once for a credit pack — no subscription, no auto-renewal. Credits never expire and work across Photo, Video and Games.',
    },
];

const STUDIOS = [
    {
        key: 'photo',
        no: '01',
        title: 'Photo Studio',
        line: 'Pick pose, clothes, location. Generate her in seconds.',
        cta: 'Open photo studio →',
        thumb: GIRL_PRESETS[0]?.img || `${CDN}/tap_game/1st/0.webp`,
    },
    {
        key: 'video',
        no: '02',
        title: 'Video Studio',
        line: 'Animate your AI photos. 12 actions, one tap.',
        cta: 'Open video studio →',
        thumb: `${CDN}/tap_game/3rd/0.webp`,
    },
    {
        key: 'games',
        no: '03',
        title: 'Games',
        line: 'Tap to reveal. Clear levels. Meet the next girl.',
        cta: 'Play now →',
        thumb: GAME_GIRLS[0]?.cover,
    },
];

export function Landing({ onNavigate, setShowPricing }) {
    return (
        <div className="landingPage">
            <div className="landingSection">
                {/* Hero */}
                <section className="landingHero">
                    <span className="landingKicker landingKicker--hero">Makeporn</span>
                    <h1 className="landingTitle">
                        Photos. Videos. Games.<br />
                        <span className="landingTitleAccent">All AI.</span>
                    </h1>
                    <p className="landingSub">
                        Built for grown-ups · 18+
                    </p>
                    <div className="landingCtaRow">
                        <button
                            className="landingCtaPrimary"
                            onClick={() => onNavigate('photo')}
                        >
                            Make a photo →
                        </button>
                        <button
                            className="landingCtaSecondary"
                            onClick={() => onNavigate('video')}
                        >
                            Make a video
                        </button>
                    </div>
                    <button
                        className="landingCtaGhost"
                        onClick={() => onNavigate('games')}
                    >
                        or play the game →
                    </button>
                </section>

                {/* Compliance ribbon */}
                <div className="landingCompliance">
                    <span className="landingComplianceDot">●</span>
                    <span className="landingComplianceText">
                        <strong>100% AI generated.</strong> No photo uploads. No real people depicted.
                    </span>
                    <button
                        className="landingComplianceLink"
                        onClick={() => onNavigate('compliance')}
                    >
                        2257 statement →
                    </button>
                </div>

                {/* Three studios */}
                <div className="landingEyebrow">Three studios</div>
                <div className="landingStudios">
                    {STUDIOS.map(s => (
                        <button
                            key={s.key}
                            type="button"
                            className="landingStudio"
                            onClick={() => onNavigate(s.key)}
                        >
                            <div className="landingStudioMedia">
                                <img
                                    src={s.thumb}
                                    alt=""
                                    draggable={false}
                                    loading="lazy"
                                />
                            </div>
                            <div className="landingStudioBody">
                                <span className="landingStudioNo">№ {s.no}</span>
                                <span className="landingStudioTitle">{s.title}</span>
                                <span className="landingStudioLine">{s.line}</span>
                                <span className="landingStudioCta">{s.cta}</span>
                            </div>
                        </button>
                    ))}
                </div>

                {/* Models strip */}
                <div className="landingEyebrow landingEyebrow--models">Models on file</div>
                <div className="landingModels">
                    {GIRL_PRESETS.map(g => (
                        <button
                            key={g.name}
                            type="button"
                            className="landingModel"
                            onClick={() => onNavigate('photo')}
                        >
                            <img src={g.img} alt={g.name} loading="lazy" draggable={false} />
                            <span className="landingModelName">{g.name}</span>
                        </button>
                    ))}
                </div>

                {/* Pricing */}
                <div className="landingEyebrow">Pricing</div>
                <div className="landingPricing">
                    {TIERS.map(t => (
                        <div
                            key={t.key}
                            className={`landingTier${t.popular ? ' landingTier--popular' : ''}`}
                        >
                            {t.badge && <span className="landingTierBadge">{t.badge}</span>}
                            <div className="landingTierHead">
                                <span className="landingTierName">{t.name}</span>
                                <div className="landingTierPriceRow">
                                    <span className="landingTierPrice">{t.price}</span>
                                    {t.old && <span className="landingTierOld">{t.old}</span>}
                                </div>
                                <span className="landingTierPer">{t.per}</span>
                            </div>
                            <ul className="landingTierFeatures">
                                {t.features.map(f => <li key={f}>{f}</li>)}
                            </ul>
                            <button
                                className={`landingTierBtn${t.popular ? ' landingTierBtn--primary' : ''}`}
                                onClick={() => setShowPricing(true)}
                            >
                                Get {t.name} →
                            </button>
                        </div>
                    ))}
                </div>
                <p className="landingPricingNote">
                    One-time payment · No subscription · Credits never expire
                </p>

                {/* FAQ */}
                <div className="landingEyebrow">FAQ</div>
                <div className="landingFaq">
                    {FAQ.map((item, i) => (
                        <div key={i} className="landingFaqItem">
                            <div className="landingFaqQ">
                                <span className="landingFaqNo">№ {String(i + 1).padStart(2, '0')}</span>
                                {item.q}
                            </div>
                            <div className="landingFaqA">{item.a}</div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer onNavigate={onNavigate} />
        </div>
    );
}
